// extracted by mini-css-extract-plugin
export default {"content":"NotificationError_content__wyr93","title":"NotificationError_title__9Ebhl","comment":"NotificationError_comment__W5jgi"};